import fetchJSON from '@api/api_helper';

const postUrl = (printerKey) => `/api/v4/printers/${printerKey}/print_requests`;

export const post = (options, updateFetchControllers) => {
  const newOptions = { ...options, method: 'POST' };
  return fetchJSON(postUrl(options.printerKey), newOptions, updateFetchControllers);
};
